import React, { useState, useEffect } from 'react';
import { OmGlyph } from './svgs';
import './Navbar.css';

export default function Navbar({ theme, toggleTheme }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const links = [
    { href: '#home', label: 'Home' },
    { href: '#about', label: 'About' },
    { href: '#journey', label: 'Visit' },
    { href: '#activities', label: 'Activities' },
    { href: '#atmanivas', label: 'Atma Nivas' },
    { href: '#community', label: 'Community' },
    { href: '#contact', label: 'Contact' },
  ];

  const handleNav = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__brand" onClick={e => handleNav(e, '#home')}>
        <OmGlyph size={38} color="#F5C842" className="navbar__om" />
        <div className="navbar__title">
          <span className="navbar__name cinzel">Vedanagari</span>
          <span className="navbar__sub devanagari">वेदनगरी आश्रम</span>
        </div>
      </div>

      <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
        {links.map(l => (
          <li key={l.href}>
            <a href={l.href} onClick={e => handleNav(e, l.href)} className="navbar__link cinzel">
              {l.label}
            </a>
          </li>
        ))}
        <li>
          <a href="#contact" onClick={e => handleNav(e, '#contact')} className="navbar__cta cinzel">
            Support Us
          </a>
        </li>
      </ul>

      <button
        className="navbar__theme-toggle"
        onClick={toggleTheme}
        aria-label="Toggle theme"
        title={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      >
        {theme === 'light' ? '☽' : '☀'}
      </button>

      <button
        className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(m => !m)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
